module.exports = __webpack_public_path__ + "static/img/container-img.0d0f0b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/container-img.jpg
// module id = U74F
// module chunks = 1